// extracted by mini-css-extract-plugin
export default {"InputLabel":"InputLabel_InputLabel__D72Ss","label":"InputLabel_label__UQ8vx","error":"InputLabel_error__rH7ms","maininput":"InputLabel_maininput__unxYr"};